import { BRAND } from "@/lib/content";

// Number must be in international format without leading + or spaces
const WA_NUMBER = (BRAND.phone_tel || "+917090103066").replace(/[^0-9]/g, "");
const WA_MESSAGE = encodeURIComponent(
  `Hi ${BRAND.short_name || "team"}, I would like to know more about your EV charging, solar and PPA services.`
);
const WA_URL = `https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`;

export default function WhatsAppFab() {
  return (
    <a
      href={WA_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="whatsapp-fab"
      className="fixed z-40 bottom-6 right-5 md:bottom-8 md:right-8 group flex items-center gap-3"
    >
      <span className="hidden md:inline-flex items-center px-4 h-11 rounded-full bg-surface border border-border text-sm font-medium text-primary shadow-md opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
        Chat on WhatsApp
      </span>
      <span className="h-14 w-14 md:h-15 md:w-15 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white flex items-center justify-center shadow-lg shadow-black/15 transition-all duration-300 hover:-translate-y-0.5">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          width="26"
          height="26"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.515 2.49-1.318.13-.302.23-.626.244-.95l.014-.146c0-.402-.066-.516-.39-.745-.215-.143-1.964-.984-2.149-.984zm-2.45 8.135c-1.706 0-3.382-.46-4.857-1.318l-.359-.215-3.616.945.97-3.53-.232-.36a9.4 9.4 0 0 1-1.488-5.06c0-5.207 4.243-9.45 9.45-9.45a9.405 9.405 0 0 1 9.45 9.45 9.405 9.405 0 0 1-9.318 9.538zm0-21.05A11.58 11.58 0 0 0 5.06 15.872 11.4 11.4 0 0 0 6.65 21.71L4.5 29.5l8.06-2.105a11.57 11.57 0 0 0 17.13-10.04A11.58 11.58 0 0 0 18.11 4.29z"/>
        </svg>
      </span>
    </a>
  );
}
